import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { PersonalHistory } from './PersonalHistory';
import { Customer } from './Customer';
import { RX as GQLRX } from '@hit/hit-api-client';

@supertypeClass({ toClient: true, toServer: true })
export class RX extends Everything implements GQLRX {
  @property({ rule: ['required'] })
  rxName: string = '';

  @property({ getType: () => PersonalHistory })
  personalHistory: PersonalHistory;

  @property()
  type: string = '';

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer) {
    return new RX().init(customer);
  }

  init(customer) {
    this.customer = customer;
    return this;
  }
}
